import { abUseExperimentsSelector, isAbUseExperimentsActive } from 'shared/selectors';
import { IState } from 'shared/store';

export const UNMATCHED_CONTENT_EXPERIMENT = 'newbuilding_booking_unmatched_content_desktop';

// TODO: Удалить селектор и константу в CD-262366.
export const selectIsUnmatchedContentExperiment = (state: IState): boolean => {
  const experiments = abUseExperimentsSelector(state);

  return isAbUseExperimentsActive(experiments, UNMATCHED_CONTENT_EXPERIMENT, 'B');
};
